import { Link } from "react-router";
import ProfileButton from "./ProfileButton";
import { UserWithMyRooms } from "@api/src/types/user";

type UserSummaryProps = {
  user: UserWithMyRooms;
};

const UserSummary = ({ user }: UserSummaryProps) => {
  return (
    <aside
      className="drop-shadow-xs relative hidden h-min w-56 shrink-0 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white px-4 pb-4 md:flex"
      id="profile"
    >
      <div
        className={`absolute left-0 top-0 flex h-20 w-full items-center justify-center bg-gray-300 bg-cover bg-center bg-no-repeat`}
        style={{ backgroundImage: user?.backgroundPic ? `url('${user?.backgroundPic}')` : "unset" }}
      />
      <ProfileButton
        className={`z-10 mx-auto mt-10 !h-20 !w-20 rounded-full border-2 text-6xl font-semibold ${
          user?.avatar ? "border-white" : "border-sky-900"
        }`}
        user={user}
      />
      <Link to={`/profile/${user.plausible_id}`} className="mt-2 font-semibold">
        {user?.firstName} {user?.lastName}
      </Link>
      <span className="mt-2 text-xs text-gray-500">{user.status_pro}</span>
      <span className="text-xs text-gray-500">{user.specialite}</span>
      <span className="text-xs text-gray-400">{user.service}</span>
    </aside>
  );
};

export default UserSummary;
